import styled from "styled-components";

import log from '@/images/month-log-btn.png'
import presenter from '@/images/month-presenter-btn.png'

const View = styled.div`
  position: absolute;
  left: 0;
  top: 1310px;
  width: 100%;
  height: 320px;
  text-align: center;

  .tip1 {
    font-size: 14px;
    line-height: 22px;
    color: #034385;
    position: absolute;
    width: 100%;
    left: 0;
    top: -32px;
    cursor: auto;
  }

  .tip2 {
    font-size: 16px;
    line-height: 20px;
    color: #034385;
    position: absolute;
    width: 100%;
    left: 0;
    top: 20px;
  }

  div.log {
    position: absolute;
    right: 145px;
    top: 32px;
    background-image: url(${log});
    width: 80px;
    height: 22px;
    cursor: pointer;
  }

  div.presenter {
    position: absolute;
    cursor: pointer;
    right: 50px;
    top: 32px;
    background-image: url(${presenter});
    width: 80px;
    height: 22px;
  }

  ul {
    width: 100%;
    text-align: center;

    li {
      display: inline-block;
      // width: 130px;
      margin: 65px 14px;
      line-height: 28px;
      font-size: 14px;
      color: #852b03;

      p {
        position: relative;
        left: 0;
        margin: 0 0;
        color: #034385;
      }
    }
  }

  div.discount {
    position: absolute;
    bottom: 18px;
    left: 30%;
    // background-image: url(\${discount});
    // width: 168px;
    // height: 58px;
    // cursor: pointer;
    // transition: all 0.3s;
    // &:hover{
    //   background-image: url(\${discountHover});
    // }
  }

  div.origin {
    position: absolute;
    bottom: 25px;
    right: 30%;
    //background-image: url(\${origin});
    //width: 168px;
    //height: 58px;
    // cursor: pointer;
    // transition: all 0.3s;
    // &:hover{
    //   background-image: url(\${originHover});
    // }
  }
`;

export {
  View
}
